export function navigate(hash: string): void {
  window.location.hash = hash;
}

export function refresh(): void {
  window.dispatchEvent(new Event('hashchange'));
}

export function scrollToSection(id: string): void {
  const current = window.location.hash.replace(/^#/, '');
  if (current !== '/' && current !== '') {
    navigate('/');
    setTimeout(() => scroll(id), 150);
  } else {
    scroll(id);
  }
}

function scroll(id: string): void {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
}
